import { WIDGET_VIEW_IMAGE } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ImageViewWidget: WidgetRegistryEntry = {
  name: WIDGET_VIEW_IMAGE,
  component: () => import("./image-view-widget.component").then((m) => m.ImageViewWidgetComponent)
};
